module.exports = __webpack_public_path__ + "img/loading-scrum.b63f866c.png";